// IE11 ignores arguments passed into the Set constructor,
// so construct the set from a specified array manually.
export default (function (ary) {
  var set = new Set();
  ary.forEach(function (elem) {
    return set.add(elem);
  });
  return set;
});